import { getClient as e, getReplay as t } from "/home/runner/work/oko-web/oko-web/node_modules/@sentry/react/build/esm/index.js";
//#region src/lib/sentry/sentryReplayCanvasSnapshots.ts
var n = 2e3, r = !1, i = () => {
	r = !0;
}, a = (i, a) => {
	let o = 0, s = () => {
		let i = performance.now();
		if (!r && i - o < n || !t()?.getRecordingMode()) return;
		let s = e()?.getIntegrationByName("ReplayCanvas");
		s && (r = !1, o = i, s.snapshot(a, { skipRequestAnimationFrame: !0 }));
	};
	return i.on("postrender", s), () => {
		i.off("postrender", s), r = !1;
	};
};
//#endregion
export { a as attachSentryReplayCanvasSnapshots, i as requestSentryReplayCanvasSnapshot };
